import {
  LIST_LEAGUES_LOADING,
  LIST_LEAGUES_SUCCESS,
  LIST_LEAGUES_ERROR,
  GET_ONE_TOURNAMENT_LOADING,
  GET_ONE_TOURNAMENT_SUCCESS,
  GET_ONE_TOURNAMENT_ERROR,
  CLEAR_TOURNMENT_DATA,
} from "../../../constant/actionTypes";

const getOneTournamentReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ONE_TOURNAMENT_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case GET_ONE_TOURNAMENT_SUCCESS: {
      let obj = {
        loading: false,
        data: action.response,
      };
      return obj;
    }
    case GET_ONE_TOURNAMENT_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    case CLEAR_TOURNMENT_DATA: {
      let obj = {
        loading: false,
        data: undefined,
      };
      return obj;
    }
    default:
      return state;
  }
};

export default getOneTournamentReducer;
